// 사용자 앱 메인 레이아웃.
// 하단 탭바가 보이는 일반 라우트(메인/카테고리/장바구니/마이페이지) 가 본 레이아웃을 공유한다.
// 로그인/OTP/약관 같이 탭바 없는 라우트는 Outlet 없는 별도 라우트로 둔다.

import { Outlet, useLocation } from "react-router-dom";
import BottomTabBar from "./BottomTabBar.tsx";
import SiteFooter from "./SiteFooter.tsx";
import PushConsentPrompt from "@/features/push/PushConsentPrompt.tsx";

// 메인 레이아웃 컴포넌트.
// 콘텐츠 영역 하단 패딩으로 탭바에 가려지지 않게 한다.
export default function MainLayout() {
  // 경로가 바뀔 때마다 콘텐츠 래퍼를 remount(key)해 페이드 인 애니메이션을 재실행한다(개선항목 17).
  // 라우트 전환 시 어차피 페이지 컴포넌트가 교체되므로 추가 비용은 없고, 부드러운 등장만 더해진다.
  const location = useLocation();
  // 사업자정보 푸터는 메인/마이페이지에서만 노출한다(전 화면 노출은 난잡 - 사용자 요청).
  //  - 카드사 심사 요건(사업자정보/정책 확인 가능)은 메인 푸터 + 마이페이지 + 고객센터 링크로 충족된다.
  const showFooter = location.pathname === "/" || location.pathname === "/me";
  return (
    <div className="min-h-dvh bg-page pb-[calc(4rem+var(--safe-bottom))] text-ink-900">
      <div key={location.pathname} className="animate-page-in">
        <Outlet />
        {/* 사업자정보 + 약관/방침/환불 링크 푸터. 메인/마이페이지에만. */}
        {showFooter ? <SiteFooter /> : null}
      </div>
      <BottomTabBar />
      {/* 첫 로그인 시 주문 알림 동의 모달(동의 시 자동 구독). 로그인 후 진입하는 화면 어디서나 1회 노출. */}
      <PushConsentPrompt />
    </div>
  );
}
